<template>
  <div>
    <div class="RouterHeaderBox" :style="{ 'background-color': color }" @mouseover="showtab1()" @mouseout="showtab2()">
      <div class="box">
        <div class="phone" v-if="detail">
          <div><img src="../assets/icon.png" alt="">{{detail.phone}}</div>
        </div>
        <div class="title" @click="back('/AboutUs',1)" :class="n == 1 ? 'activee' : ''">
          {{lan=="en" ? 'About Amore' : '关于爱醇'}}
          <div class="title-b" :class="n == 1 ? 'active' : ''"></div>
          <!-- <div class="title-c">
                <div>葡萄酒文化</div>
                <div>葡萄酒文化</div>
                <div>葡萄酒文化</div>
              </div> -->
        </div>
        <div class="title" @click="back('/WineCulture',2)" :class="n == 2 ? 'activee' : ''">
          {{lan=="en" ? 'Brand Culture' : '葡萄酒文化'}}
          <div class="title-b" :class="n == 2 ? 'active' : ''"></div>
        </div>
        <div class="title" @click="back('/ProductList',3)" :class="n == 3 ? 'activee' : ''">
          {{lan=="en" ? 'Brand Products' : '品牌产品'}}
          <div class="title-b" :class="n == 3 ? 'active' : ''"></div>
        </div>
        <div class="title" @click="back('/')">
          <img src="@/assets/logo.png" alt="">
        </div>
        <div class="title" @click="back('/InformationList',4)" :class="n == 4 ? 'activee' : ''">
          {{lan=="en" ? 'Wine Information' : '美酒资讯'}}
          <div class="title-b" :class="n == 4 ? 'active' : ''"></div>
        </div>
        <div class="title" @click="back('/WineryList',5)" :class="n == 5 ? 'activee' : ''">
          {{lan=="en" ? 'Winery Culture' : '酒庄文化'}}
          <div class="title-b" :class="n == 5 ? 'active' : ''"></div>
        </div>
        <div class="title" @click="back('/PromotionCooperation',6)" :class="n == 6 ? 'activee' : ''">
          {{lan=="en" ? 'Promotion Cooperation' : '推广合作'}}
          <div class="title-b" :class="n == 6 ? 'active' : ''"></div>
        </div>
        <div class="title" @click="change()">
          <img src="../assets/zn.png" class="fy" alt="" v-if="lan=='cn'">
          <img src="../assets/cn.png" class="fy" alt="" v-else>
        </div>
      </div>
    </div>
    <div class="q">
      <div class="header">
        <div class="header-img" @click="back('/')">
          <img src="@/assets/logo.png" alt="" class="SchoolLogo" />
        </div>
        <div class="header-img1" @click="drawer = true" type="primary">
          <img src="../assets/nav.png" alt="" />
        </div>
      </div>
    </div>
    <div style="z-index: 999999999999999;">
      <el-drawer :visible.sync="drawer" :direction="direction">
        <div class="" @click="back('/')">
          {{lan=="en" ? 'Home' : '首页'}}
        </div>
        <div class="" @click="back('/ProductList')">
          {{lan=="en" ? 'Product Introduction' : '爱醇产品'}}
        </div>
        <div class="" @click="back('/InformationList')">
          {{lan=="en" ? 'Wine Information' : '美酒资讯'}}
        </div>
        <div class="" @click="back('/WineryList')">
          {{lan=="en" ? 'Winery Culture' : '酒庄文化'}}
        </div>
        <div class="" @click="back('/AboutUs')">
          {{lan=="en" ? 'About Us' : '关于爱醇'}}
        </div>
        <div class="" @click="back('/WineCulture')">
          {{lan=="en" ? 'Brand Culture' : '葡萄酒文化'}}
        </div>
        <div class="" @click="back('/PromotionCooperation')">
          {{lan=="en" ? 'Promotion Cooperation' : '推广合作'}}
        </div>
        <div class="fay" @click="change()">
          <img src="../assets/zn.png" class="fayi" alt="" v-if="lan=='cn'">
          <img src="../assets/cn.png" class="fayi" alt="" v-else>
          <!-- <img src="../assets/fy.png" class="fayi" alt=""> -->
        </div>
        <div class="ph" v-if="detail" @click="callPhone(detail.phone)">
          <img src="../assets/icon.png" class="phon" alt="">{{detail.phone}}
        </div>
      </el-drawer>
    </div>
    
   <a href="" v-show="false" ref="tels"></a>
  </div>
</template>
<script>
  export default {
    props: {
      lan: String,
      n:Number
    },
    data() {
      return {
        drawer: false,
        direction: 'rtl',
        color: '',
        height: '',
        detail:''
      };
    },
    watch: {},
    mounted() {
      let that = this;
      window.onscroll = () => {
        let height = window.innerHeight / 3;
        that.color = `rgba(30,30,30,${document.documentElement.scrollTop /
          height})`;
      };
      this.seo()
    },
    methods: {
      callPhone (phoneNumber) {
       this.$refs.tels.href = `tel://`+phoneNumber
        this.$refs.tels.click()
      },
      seo() {
        this.$http
        .post("/index/seo/list", {})
        .then((res) => {
          if (res.data.code == 0) {
            this.detail = res.data.data;
            console.log(res.data.data);
          }
        });
      },
      showtab1() {
        this.color = `rgba(30,30,30,1)`;
        clearTimeout(this.timeout)
      },
      showtab2() {
        this.timeout = setTimeout(() => {
          let height = window.innerHeight / 3;
          this.color = `rgba(30,30,30,${document.documentElement.scrollTop /
            height})`;
        }, 100)
      },
      back(i, idx) {
        // this.n = idx
        this.$router.push(i);
        this.drawer = false
      },
      change() {
        let lan = sessionStorage.getItem('lan');
        if (lan == 'cn') {
          sessionStorage.setItem('lan', "en");
          this.$emit('change')
        } else {
          sessionStorage.setItem('lan', "cn");
          this.$emit('change')
        }
        this.drawer = false
      }
    },
  };
</script>
<style lang="scss" scoped>
  .q {
    display: none;

    @media (max-width: 1199px) {
      display: block;
      height: 59.88px;
    }
  }

  .fay {
    border-bottom: 0px solid #fff !important;
    margin-bottom: 30px;
    overflow: hidden;
    margin-top: 30px;
  }

  .fayi {
    margin: auto;
    border-top: 0px solid #fff !important;
    margin-top: 9px;
    @media (max-width: 1199px) {
      width: 25px;
      height: 25px;
    }
  }

  .ph {
    border-bottom: 0px solid #fff !important;
    display: flex;
    justify-content: center;

  }

  .phon {
    margin-top: 10px;
    width: 30px;
    height: 30px;
    border-top: 0px solid #fff !important;
    margin-right: 5px;
    @media (max-width: 1199px) {
      width: 25px;
      height: 25px;
      margin-top: 13px;
    }
  }

  .header {
    width: 100%;
    height: 59.88px;
    position: fixed;
    top: 0;
    z-index: 9;
    display: flex;
    justify-content: space-between;
    background: #222222;

    // background: linear-gradient(90deg, #d80c24 0%, #b01f24 100%);
    .header-img {
      img {
        width: 80px;
        padding-bottom: 0px;
        margin-top: 10.8px;
        margin-left: 19px;
      }
    }

    .header-img1 {
      img {
        width: 30px;
        margin-top: 15px;
        margin-right: 19px;
      }
    }
  }

  .RouterHeaderBox {
    transition: .3s all linear;
    width: 100%;
    height: 100px;
    // background-color: #333;
    position: fixed;
    top: 0;
    z-index: 99999999999999999;
    opacity: 1;
    display: block;

    @media (max-width: 1199px) {
      display: none;
      // height: 50px;
    }

    .box {
      width: 1600px;

      @media (max-width: 1499px) {
        width: 1300px;
      }

      height: 100px;
      // line-height: 100px;
      margin: auto;
      // background-color: white;
      display: flex;
      justify-content: space-around;

      // align-items: center;
      // .img{
      //   width: 200px;
      //   height: auto;
      //   img{
      //     width: 100px;
      //     margin-left: 50px;
      //     margin-top: 26px;
      //   }
      // }
      .phone {
        width: calc(100% / 7);

        // display: flex;
        // align-items: center;
        div {
          height: 100%;
          display: flex;
          align-items: center;
          // flex-direction: column;
          justify-content: center;
          color: white;
        }

        img {
          width: 20px;
          height: 20px;
          margin: 0;
          margin-top: 0px;
          margin-right: 5px;
        }
      }
      .title:hover {
        color: #C5A176;
      }
      .activee{
        color: #C5A176 !important;
      }
      .title {
        height: 100%;
        font-size: 15px;
        text-align: center;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: calc(100% / 7);
        // color: black;
        color: white;
        font-family: Source Han Sans SC-Light, Source Han Sans SC;
        cursor: pointer;
        position: relative;
        .title-c {
          width: 100%;
          height: auto;
          position: absolute;
          top: 100px;
          background-color: #333;
          left: 0%;

          div {
            width: 100%;
            height: 50px;
            text-align: center;
            line-height: 50px;
            color: white;
          }
        }

        .title-b {
          width: 30%;
          height: 2px;
          background-color: #c5a176;
          position: absolute;
          bottom: 20px;
          left: 35%;
          display: none;
        }

        .active {
          display: block;
        }
        img {
          width: 100px;
          margin: auto;
          margin-top: 26px;
        }

        .fy {
          width: 25px;
          height: 25px;
          margin: 0;
          margin-top: 0px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RouterHeader.vue